import React, { useState } from 'react'

export default function QuizField({ id, setQuizOption }) {
    const [optionTitle, setOptionTitle] = useState("")
    const [checkBoxValue, setCheckBoxValue] = useState(false)

    return (
        <div className='col-span-6 flex justify-start items-center gap-4'>
            <div>
                <input value={checkBoxValue} onChange={e => {
                    setCheckBoxValue(e.target.checked)
                    setQuizOption({
                        id,
                        option: optionTitle,
                        isCorrect: e.target.checked
                    })

                }} type="checkbox" name="checkbox" />
            </div>
            <div className='w-full'>
                <input type="text" placeholder='Enter option title' onChange={e => {
                    setOptionTitle(e.target.value)
                    setQuizOption({
                        id,
                        option: e.target.value,
                        isCorrect: checkBoxValue
                    })

                }} value={optionTitle} name="option" className="border rounded-lg  block w-full p-1 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
            </div>
        </div>

    )
}
